import React, { useContext } from 'react';

import WidgetContext from '@totem/components/customDashboard/home/widgets/WidgetContext';
import DeviceSoftwareEndOfSupportContainer from '@totem/components/devices/softwareEndOfLife/summary/DeviceSoftwareEndOfSupportContainer';
import FutureEndOfLifeReport from '@totem/components/devices/softwareEndOfLife/summary/FutureEndOfLifeReport';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const WidgetNearEndOfSupportReport = () => {
  const { onSetTitle, componentInstance } = useContext(WidgetContext);

  return (
    <DeviceSoftwareEndOfSupportContainer
      onRecordTotalNearChanged={(recordCount: number) =>
        onSetTitle(<RecordCountBadge count={recordCount} />)
      }
    >
      <FutureEndOfLifeReport
        componentKey={`${componentInstance.componentInstanceId}`}
      />
    </DeviceSoftwareEndOfSupportContainer>
  );
};

export default WidgetNearEndOfSupportReport;
